import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { AppearanceProvider } from "@/lib/appearance";
import { Toaster } from "sonner";
import LoginPage from "@/pages/LoginPage";
import Layout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import ProductsPage from "@/pages/ProductsPage";
import MovementsPage from "@/pages/MovementsPage";
import CategoriesPage from "@/pages/CategoriesPage";
import SuppliersPage from "@/pages/SuppliersPage";
import ReportsPage from "@/pages/ReportsPage";
import SettingsPage from "@/pages/SettingsPage";

function Protected() {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 tabular" data-testid="auth-loading">
        Caricamento…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function AuthRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  return user ? <Navigate to="/" replace /> : <LoginPage />;
}

export default function App() {
  return (
    <AppearanceProvider>
      <AuthProvider>
      <BrowserRouter basename="/magazzino">
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<AuthRedirect />} />
          <Route element={<Protected />}>
            <Route element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="/prodotti" element={<ProductsPage />} />
              <Route path="/movimenti" element={<MovementsPage />} />
              <Route path="/categorie" element={<CategoriesPage />} />
              <Route path="/fornitori" element={<SuppliersPage />} />
              <Route path="/report" element={<ReportsPage />} />
              <Route path="/impostazioni" element={<SettingsPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      </AuthProvider>
    </AppearanceProvider>
  );
}
